/* nrt-shop-v1 */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    /* ── PLP filter group toggles ── */
    document.querySelectorAll('.nrt-fgroup').forEach(function (g) {
      var head = g.querySelector('.nrt-fgroup__head');
      var body = g.querySelector('.nrt-fgroup__body');
      var t = head && head.querySelector('.toggle');
      if (!head || !body) return;
      head.addEventListener('click', function () {
        var open = body.style.display !== 'none';
        body.style.display = open ? 'none' : '';
        if (t) t.textContent = open ? '+' : '−';
      });
    });

    /* ── PLP view toggle (cols) ── */
    var grid = document.querySelector('.nrt-plp__grid');
    document.querySelectorAll('.nrt-plp__view button').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = b.getAttribute('data-cols');
        if (!grid || !n) return;
        grid.setAttribute('data-cols', n);
        document.querySelectorAll('.nrt-plp__view button').forEach(function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active');
        try { localStorage.setItem('nrt-plp-cols', n); } catch (e) {}
      });
    });
    /* Restore preferred cols */
    try {
      var saved = localStorage.getItem('nrt-plp-cols');
      if (saved && grid) {
        grid.setAttribute('data-cols', saved);
        var btn = document.querySelector('.nrt-plp__view button[data-cols="' + saved + '"]');
        if (btn) {
          document.querySelectorAll('.nrt-plp__view button').forEach(function (x) { x.classList.remove('is-active'); });
          btn.classList.add('is-active');
        }
      }
    } catch (e) {}

    /* ── PDP gallery thumb selection ── */
    var pdp = document.querySelector('.nrt-pdp');
    if (pdp) {
      var thumbs = pdp.querySelectorAll('.nrt-pdp__thumb');
      var mainImg = pdp.querySelector('.nrt-pdp__main img');
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          thumbs.forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
          var src = t.getAttribute('data-image');
          if (mainImg && src) mainImg.src = src;
        });
      });

      /* Variant pickers (color circles + size chips) */
      var variantData = pdp.querySelector('[data-nrt-variants]');
      var variants = [];
      if (variantData) { try { variants = JSON.parse(variantData.textContent || '[]'); } catch (e) { variants = []; } }
      var optionState = {};

      function findVariant() {
        return variants.find(function (v) {
          return Object.keys(optionState).every(function (key, i) {
            return v.options[i] === optionState[key];
          });
        });
      }

      function updatePrice(v) {
        var priceEl = pdp.querySelector('.nrt-pdp__price');
        var compareEl = pdp.querySelector('.nrt-pdp__compare');
        var addBtn = pdp.querySelector('.nrt-pdp__add');
        var stockEl = pdp.querySelector('.nrt-pdp__stock');
        var idInput = pdp.querySelector('input[name="id"]');
        if (!v) return;
        if (priceEl) priceEl.textContent = v.price;
        if (compareEl) {
          if (v.compare_at && v.compare_at !== v.price) {
            compareEl.textContent = v.compare_at;
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }
        if (stockEl) stockEl.style.display = v.available ? '' : 'none';
        if (addBtn) {
          addBtn.disabled = !v.available;
          addBtn.textContent = v.available ? ('Add to bag — ' + v.price) : 'Sold out';
        }
        if (idInput) idInput.value = v.id;
        var qty = parseInt((pdp.querySelector('.nrt-pdp__qty input') || {}).value || '1', 10) || 1;
        if (addBtn && v.available) addBtn.textContent = 'Add to bag — ' + v.price;
      }

      pdp.querySelectorAll('.nrt-pdp__color-swatch').forEach(function (s) {
        s.addEventListener('click', function () {
          var key = s.getAttribute('data-option-name');
          var val = s.getAttribute('data-option-value');
          optionState[key] = val;
          pdp.querySelectorAll('.nrt-pdp__color-swatch[data-option-name="' + key + '"]').forEach(function (x) { x.classList.remove('is-active'); });
          s.classList.add('is-active');
          var label = pdp.querySelector('[data-color-label]');
          if (label) label.textContent = val;
          updatePrice(findVariant());
        });
      });
      pdp.querySelectorAll('.nrt-pdp__size-chip').forEach(function (c) {
        c.addEventListener('click', function () {
          if (c.disabled) return;
          var key = c.getAttribute('data-option-name');
          var val = c.getAttribute('data-option-value');
          optionState[key] = val;
          pdp.querySelectorAll('.nrt-pdp__size-chip[data-option-name="' + key + '"]').forEach(function (x) { x.classList.remove('is-active'); });
          c.classList.add('is-active');
          updatePrice(findVariant());
        });
      });
      /* Initialize: select first variant */
      if (variants.length > 0) {
        var v0 = variants[0];
        var optNames = Array.from(pdp.querySelectorAll('[data-option-key]')).map(function (e) { return e.getAttribute('data-option-key'); });
        optNames.forEach(function (k, i) { optionState[k] = v0.options[i]; });
        Object.keys(optionState).forEach(function (k) {
          var val = optionState[k];
          var el = pdp.querySelector('[data-option-name="' + k + '"][data-option-value="' + val + '"]');
          if (el) el.classList.add('is-active');
        });
        updatePrice(v0);
      }

      /* Qty stepper */
      var qtyInput = pdp.querySelector('.nrt-pdp__qty input');
      pdp.querySelectorAll('.nrt-pdp__qty button').forEach(function (b) {
        b.addEventListener('click', function () {
          if (!qtyInput) return;
          var dir = b.getAttribute('data-dir');
          var v = parseInt(qtyInput.value || '1', 10) || 1;
          v = dir === '+' ? v + 1 : Math.max(1, v - 1);
          qtyInput.value = v;
        });
      });

      /* Tabs */
      var tabBtns = pdp.querySelectorAll('.nrt-pdp__tab-btn');
      var panels = pdp.querySelectorAll('.nrt-pdp__tab-panel');
      tabBtns.forEach(function (b) {
        b.addEventListener('click', function () {
          var t = b.getAttribute('data-tab');
          tabBtns.forEach(function (x) { x.classList.remove('is-active'); });
          b.classList.add('is-active');
          panels.forEach(function (p) {
            if (p.getAttribute('data-panel') === t) p.removeAttribute('hidden');
            else p.setAttribute('hidden', '');
          });
        });
      });

      /* AJAX add to cart */
      var form = pdp.querySelector('form[data-nrt-pdp-form]');
      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var data = new FormData(form);
          fetch('/cart/add.js', { method: 'POST', body: data, headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function () {
              /* Trigger cart drawer if available; else go to /cart */
              if (window.nrtCartDrawer && typeof window.nrtCartDrawer.open === 'function') {
                window.nrtCartDrawer.refresh().then(function () { window.nrtCartDrawer.open(); });
              } else {
                window.location.href = '/cart';
              }
            })
            .catch(function () { window.location.href = '/cart'; });
        });
      }
    }
  });
})();


/* === NRT-MOBILE-FILTER-DRAWER-JS START === */
(function(){
  function ready(fn){document.readyState!=="loading"?fn():document.addEventListener("DOMContentLoaded",fn);}
  function isMobile(){return window.matchMedia("(max-width: 749px)").matches;}

  ready(function(){
    var drawer = document.getElementById("nrt-plp-drawer");
    if (!drawer) return;

    var openBtn = document.querySelector("[data-nrt-open-filters]");
    var closers = document.querySelectorAll("[data-nrt-close-filters]");
    var applyBtn = document.querySelector("[data-nrt-apply-filters]");
    var form = document.getElementById("nrt-plp-filters");

    function open(){
      document.body.classList.add("nrt-filters-open");
      drawer.setAttribute("aria-hidden","false");
      openBtn && openBtn.setAttribute("aria-expanded","true");
      var bd = document.querySelector(".nrt-plp__drawer-backdrop");
      bd && bd.removeAttribute("hidden");
    }
    function close(){
      document.body.classList.remove("nrt-filters-open");
      drawer.setAttribute("aria-hidden","true");
      openBtn && openBtn.setAttribute("aria-expanded","false");
      var bd = document.querySelector(".nrt-plp__drawer-backdrop");
      // Keep [hidden] off so opacity transition can run, but on close we
      // rely on opacity:0/pointer-events:none from CSS.
    }
    openBtn && openBtn.addEventListener("click", open);
    closers.forEach(function(el){ el.addEventListener("click", close); });
    document.addEventListener("keydown", function(e){
      if (e.key === "Escape" && document.body.classList.contains("nrt-filters-open")) close();
    });

    // Filter group collapse — re-bind for mobile-specific 'is-open' class
    // (the existing nrt-shop.js sets style.display, which won't play with
    // our class-based mobile rule). Toggle is-open on the group.
    document.querySelectorAll(".nrt-fgroup").forEach(function(g){
      var head = g.querySelector(".nrt-fgroup__head");
      if (!head) return;
      // Default state on desktop: open. On mobile: closed (handled by CSS
      // hiding .nrt-fgroup__body and showing only when .is-open).
      if (!isMobile()) g.classList.add("is-open");
      head.addEventListener("click", function(e){
        // Avoid double-handling with the legacy inline-display handler.
        e.stopImmediatePropagation();
        var open = g.classList.toggle("is-open");
        var body = g.querySelector(".nrt-fgroup__body");
        if (body) body.style.display = ""; // let CSS decide
        head.setAttribute("aria-expanded", open ? "true" : "false");
      });
    });

    // data-auto-submit handler — desktop auto-submits on change; mobile
    // defers until Apply tap.
    form && form.querySelectorAll("[data-auto-submit]").forEach(function(el){
      el.addEventListener("change", function(){
        if (!isMobile()) {
          form.submit();
        }
      });
    });

    applyBtn && applyBtn.addEventListener("click", function(){
      if (form) form.submit();
    });
  });
})();
/* === NRT-MOBILE-FILTER-DRAWER-JS END === */
